import { takeEvery, fork, put, all, call } from 'redux-saga/effects';

import { customHeaders, adminAPIURL } from '../../../../../Containers/Config/index.js';
import { ACKNOWLEDGE_CLOSURE, ACKNOWLEDGE_CLOSURE_SUCCESS, ACKNOWLEDGE_CLOSURE_ERROR } from '../../actions.js';
import apiCall from '../../../apiCall.js';
import cogoToast from 'cogo-toast';

function* acknowledgeClosure({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const { ticketId } = payload;

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v2/ticket-system/tickets/callback-queue/${ticketId}/close`,
      method: 'POST',
      data: payload?.data,
      headers: {
        // Authorization: Constant?.CLIENT_TOKEN,
        ...filteredHeaders,
        // withCredentials: true
      },
    });

    if (response.status === 200) {
      cogoToast.success(`${response?.data?.message}`);

      yield put({
        type: ACKNOWLEDGE_CLOSURE_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(`${response?.response?.data?.message}`);
      yield put({
        type: ACKNOWLEDGE_CLOSURE_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: ACKNOWLEDGE_CLOSURE_ERROR, payload: error });
  }
}

export function* watchAcknowledgeClosure() {
  yield takeEvery(ACKNOWLEDGE_CLOSURE, acknowledgeClosure);
}

function* acknowledgeClosureSaga() {
  yield all([fork(watchAcknowledgeClosure)]);
}

export default acknowledgeClosureSaga;
